import { z } from 'zod';

export const accessListBadgeSchema = z.object({
	badgeUID: z.string().optional(),
	userSecret: z.string().optional(),
	userPassword: z.string().optional(),
});

export const accessListUserSchema = z.object({
	id: z.string().optional(),
	facePrintRSID: z.any().optional(),
	authSecret: z.string().optional(),
	badgeId: z.string().optional(),
	badges: z.array(accessListBadgeSchema).optional(),
	ignoreWhenDirectional: z.boolean().optional(),
	excludeFromChecks: z.boolean().optional(),
	roleIds: z.array(z.string()).optional(),
});

export const accessListSchema = z.object({
	zoneId: z.string(),
	zoneName: z.string(),
	users: z.array(accessListUserSchema).default([]),
	hash: z.string(),
	timestamp: z.date(),
});
